import PropTypes from 'prop-types'
import React from 'react'

import getDecimalValue from 'utils/get-decimal-value'

import {
  ItemContainer,
  Logo,
  InfoContainer,
  TitleContainer,
  TitleText,
  DatePill,
  DetailsContainer,
  RecordsText,
  DetailsText,
} from './styles'

const formatBreachDate = (isoDateString) => {
  try {
    const date = new Date(isoDateString)
    return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short' }).format(date)
  } catch {
    return 'Unknown date'
  }
}

const formatPwnCount = (rawCount) => {
  const count = getDecimalValue(rawCount)

  if (!count || count.isZero() || count.isNaN()) {
    return 'Size Unknown'
  }

  if (count.greaterThanOrEqualTo(1_000_000)) {
    return `${count.dividedBy(1_000_000).toDecimalPlaces(0)}M records`
  }

  if (count.greaterThanOrEqualTo(1_000)) {
    return `${count.dividedBy(1_000).toDecimalPlaces(0)}K records`
  }

  return '<1K records'
}

const DataBreachItem = ({ breach }) => {
  const { logoPath, breachTitle, breachDate, pwnCount, dataClasses } = breach

  return (
    <ItemContainer>
      <Logo src={logoPath} alt={`${breachTitle} logo`} />
      <InfoContainer>
        <TitleContainer>
          <TitleText>{breachTitle}</TitleText>
          <DatePill>{formatBreachDate(breachDate)}</DatePill>
        </TitleContainer>
        <DetailsContainer>
          <DetailsText>
            <RecordsText>{formatPwnCount(pwnCount)}</RecordsText>
            {dataClasses?.length ? ` | ${dataClasses.join(', ')}` : ''}
          </DetailsText>
        </DetailsContainer>
      </InfoContainer>
    </ItemContainer>
  )
}

DataBreachItem.propTypes = {
  breach: PropTypes.shape({
    breachName: PropTypes.string.isRequired,
    breachTitle: PropTypes.string.isRequired,
    breachDate: PropTypes.string.isRequired,
    logoPath: PropTypes.string,
    pwnCount: PropTypes.number,
    dataClasses: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
}

export default DataBreachItem
